import { inject } from '@angular/core';
import { type CanDeactivateFn } from '@angular/router';

import { UnsavedChangesService } from '@core/services/unsaved-changes.service';

/**
 * Asks before a route with unsaved edits is left (link, back button). Forms register their state with
 * `UnsavedChangesService.track`; the guard only asks if one of them reports edits.
 *
 * Usage in routes: `canDeactivate: [unsavedChangesGuard]`
 */
export const unsavedChangesGuard: CanDeactivateFn<unknown> = () => {
  const unsaved = inject(UnsavedChangesService);
  return unsaved.hasUnsaved() ? unsaved.confirmLeave() : true;
};
